<div *ngIf="formObject">

  <div style="display: flex; margin-bottom: 1em"
       class="flex-row justify-content-end"
       *ngIf="isTranslated">
    <a mat-raised-button
       class="lang-button"
       [ngClass]="{'lang-active-button': selectedInputLanguage === 'SK'}"
       (click)="onLanguageChange('SK')">
      <img src="assets/images/flags/sk.png" alt="sk_flag" class="lang-icon">
      SK
    </a>
    <a mat-raised-button
       class="lang-button"
       [ngClass]="{'lang-active-button': selectedInputLanguage === 'EN'}"
       (click)="onLanguageChange('EN')">
      <img src="assets/images/flags/gb.png" alt="gb_flag" class="lang-icon">
      EN
    </a>
  </div>

  <!--    <mat-button-toggle-group style="float: right; margin-bottom: 1em"-->
  <!--                             appearance="legacy"-->
  <!--                             *ngIf="isTranslated"-->
  <!--                             [(ngModel)]="selectedInputLanguage"-->
  <!--                             (ngModelChange)="onLanguageChange($event)"-->
  <!--    >-->
  <!--      <mat-button-toggle value="SK" class="lang-button">-->
  <!--        <img src="assets/images/flags/sk.png" alt="sk_flag" class="lang-icon">-->
  <!--        SK-->
  <!--      </mat-button-toggle>-->
  <!--      <mat-button-toggle value="EN" class="lang-button">-->
  <!--        <img src="assets/images/flags/gb.png" alt="gb_flag" class="lang-icon">-->
  <!--        EN-->
  <!--      </mat-button-toggle>-->
  <!--    </mat-button-toggle-group>-->

  <mat-form-field appearance="fill" class="w-100">
    <mat-label [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">{{label}}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <textarea matInput #inputElement
              [ngStyle]="height ? {height: height + 'px'} : {}"
              [required]="required"
              [placeholder]="label"
              [maxlength]="lengthLimitation"
              [name]="elementName"
              [disabled]="isDisabled"
              [matAutocomplete]="auto"
              [rows]="rows"
              [(ngModel)]="ngModelObject"
              (focusin)="getOptions(ngModelObject)"
              (focusout)="emitValue()"
              (ngModelChange)="emitChangeToGetOptions($event, inputElement)">
    </textarea>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedOption($event)">
      <mat-option *ngFor="let option of options" [value]="option">
        {{option}}
      </mat-option>
    </mat-autocomplete>
    <mat-hint *ngIf="lengthLimitation" align="end">{{inputElement.value.length}} / {{lengthLimitation}}</mat-hint>
  </mat-form-field>
</div>
